// Echte Google-Bewertungswerte — EINE Quelle für Hero und Belege
export const GOOGLE_STERNE = "4,7";
export const GOOGLE_BEWERTUNGEN = 100;